module.exports = __webpack_public_path__ + "img/banner_skylife_promo_01.4cbbf347.png";